import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DocumentSelectionSearchSchema } from './document-selection/-zod-schema';
export const Route = createFileRoute('/_staff/labor-core/document-selection')({
  validateSearch: zodValidator(DocumentSelectionSearchSchema)
});